import React from 'react';
import { useTranslations } from '@lang';
import { ChildAgesContainer, Select, SpecialLabel } from './ChildAges.styles';

export type ChildAgesProps = {
  childCount: number;
  minChildAge: number;
  maxChildAge: number;
  onChildAgeChange: (ages: { [child: string]: number }) => void;
  childAgeValues: { [child: string]: number };
  isSubmitted: boolean;
  errors: string[];
};

export function ChildAges({
  childCount,
  minChildAge,
  maxChildAge,
  onChildAgeChange,
  childAgeValues,
  isSubmitted,
  errors,
}: ChildAgesProps) {
  if (minChildAge >= maxChildAge) {
    console.warn('Minimum child age greater than maximum child age.');
    return null;
  }
  const { t } = useTranslations();
  const ageRangeOptions = new Array(maxChildAge - minChildAge + 1).fill({}).map((_, i) => ({
    label: `${i + minChildAge === 0 ? t('guestsPicker.ageUnderOne') : i + minChildAge}`,
    value: i + minChildAge,
  }));

  return (
    <ChildAgesContainer>
      {new Array(childCount).fill({}).map((_, i) => {
        const childNumber = i + 1;
        const childLabel = `child${childNumber}`;
        const specialLabel = (
          <SpecialLabel>{t('guestsPicker.ageSelectLabel', { childNumber })}</SpecialLabel>
        );
        const error =
          isSubmitted && errors.includes(childLabel) ? t('guestsPicker.ageSelectError') : undefined;

        return (
          <Select
            specialLabel={specialLabel}
            key={`${childLabel}-age`}
            aria-label={`select-${childLabel}-age`}
            options={ageRangeOptions}
            onChange={({ value }) => onChildAgeChange({ ...childAgeValues, [childLabel]: value })}
            placeholder={t('guestsPicker.agePlaceholder', { childNumber })}
            value={ageRangeOptions.find((o) => o.value === childAgeValues[childLabel])}
            error={error}
            useNativeDropdownOnMobile={false}
          />
        );
      })}
    </ChildAgesContainer>
  );
}
